import create from "zustand";

interface ModalState {
  id: string | null;
  classe: string | null;
  isOpen: boolean;
  isEditing: boolean;
  record: any;
  setRecord: (args: any) => void;
  setId: (args: string | null) => void;
  setClasse: (args: string) => void;
  setIsOpen: (args: boolean) => void;
  setIsEditing: (args: boolean) => void;
}

const useModal = create<ModalState>((set) => ({
  id: null,
  classe: null,
  isOpen: false,
  isEditing: false,
  record: null,
  setId: (id) => {
    set((state) => ({ id }));
  },
  setClasse: (classe) => {
    set((state) => ({ classe }));
  },
  setIsOpen: (isOpen) => {
    set((state) => ({ isOpen }));
  },
  setIsEditing: (isEditing) => {
    set((state) => ({ isEditing }));
  },
  setRecord: (record) => {
    set((state) => ({ record }));
  },
}));

export default useModal;
